import api from "api";

export const getIncenctiveSlabData = (params) => {
  return api.get("v1/incentive/monthlySlab" + params);
};

export const getIncenctiveSlabFilterData = () => {
  return api.get("v1/incentive/monthlySlabFilters");
};

export function editIncenctiveSlabData(payload) {
  return api.put(`v1/incentive/monthlySlab`, payload);
}
